import { FC } from "react";

import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";

export const UnassessablePageSubmissionsBanner: FC = () => (
  <Banner kind="warning">{t("warning.unassessable_page_submissions")}</Banner>
);
